import React, { Component } from 'react';
import { connect } from 'react-redux';
import { saveSafeManagement } from 'actions/EntityActions';
import { clearFormInput }from 'actions/FormActions';
import { showSnackbar } from 'actions/CommonActions';
import LOOKUP from 'constants/lookup';
import { selectSafeManagementModel } from 'selectors/entitySelector';
import { safeManageMentAdjustmentCrumb } from 'utils/breadcrumbInfo';
import util from 'library/util';
// Basic Components
import Grid from 'screens/components/basic/Grid';
import CardSimple from 'screens/components/basic/CardSimple';
import TextInput from 'screens/components/basic/TextInput';
import Button from 'screens/components/basic/Button';
import DecimalInput from 'screens/components/basic/DecimalInput';
import SelectInput from 'screens/components/basic/SelectInput';
import PageHeader from 'screens/components/basic/PageHeader';
import PageBottomWithButtons from 'screens/components/basic/PageBottomWithButtons';

const compName = "SafeManagementSave"

class SafeManagementSave extends Component {
  constructor(props) {
    super(props);
  }

  componentDidMount() {
    this.clearFormInputs();
  }

  componentDidUpdate(prevProps){
    if (this.props.saveSuccess && this.props.saveSuccess !== prevProps.saveSuccess) {
        this.saveSuccess();
    }

    if (this.props.saveError && this.props.saveError !== prevProps.saveError) {
        this.saveError();
    }
  }

  saveError = () => {
    this.props.showSnackbar(this.props.saveError);
    this.props.clearFormInput(`${compName}SaveSuccess`);
    this.props.clearFormInput(`${compName}SaveError`);
  }

  saveSuccess = () => {
    this.clearFormInputs();
    this.props.callListView();
    this.props.showSnackbar(LOOKUP.safemanagement.messages.createdMessage);
  }

  cancelSafeManagement = () => {
    this.props.callListView();
  }

  saveSafeManagement = () => {
    let model = this.props.safeManagementModel;
    
    const validators = [
      [compName + 'Amount', model => (model.amount > 0), "Amount"],
      [compName + 'Type', model => (model.type != null), "Type"]
    ];

    if (util.validate(validators, model, this.props.formError)) {
        this.props.saveSafeManagement(model);
    }
  };

  clearFormInputs = () => {
    this.props.clearFormInput(`${compName}Amount`);
    this.props.clearFormInput(`${compName}Type`);
    this.props.clearFormInput(`${compName}Notes`);
    this.props.clearFormInput(`${compName}SaveSuccess`);
    this.props.clearFormInput(`${compName}SaveError`);
  }

  render() {
    const safemanagementcrumb =  safeManageMentAdjustmentCrumb

    return (
      <Grid headerContent={safemanagementcrumb}>
        <PageHeader title="Safe Management Adjustment" />
        <CardSimple className="p-1">
          <div className="row">
            <div className="col-lg-12">
              <DecimalInput
                name={`${compName}Amount`}
                label={LOOKUP.safemanagement.fields.amount.label}
                floatingLabelText={LOOKUP.safemanagement.fields.amount.label}
                hintText={LOOKUP.safemanagement.fields.amount.hint}
                fullWidth={true}
              />
            </div>
            <div className="col-lg-12">
              <SelectInput
                name={`${compName}Type`}
                options={LOOKUP.safemanagement.types}
                className="search-field"
                label={LOOKUP.safemanagement.fields.types.label}
                floatingLabelText={LOOKUP.safemanagement.fields.types.label}
                hintText={LOOKUP.safemanagement.fields.types.hint}
                required
              />
            </div>
            <div className="col-lg-12">
              <TextInput
                name={`${compName}Notes`}
                label={LOOKUP.safemanagement.fields.notes.label}
                floatingLabelText={LOOKUP.safemanagement.fields.notes.label}
                hintText={LOOKUP.bankdeposits.fields.notes.hint}
                fullWidth={true}
              />
            </div>
          </div>
        </CardSimple>
        <PageBottomWithButtons>
          <Button name="buttonSave"
            className="pull-right btnNewBrandPOS"
            label={LOOKUP.safemanagement.controls.saveButton}
            primary={true}
            onTouchTap={() => this.saveSafeManagement()} />
          <Button name="cancelButton"
            className="pull-right btn-space btnCleanSearch"
            label={LOOKUP.safemanagement.controls.cancelButton}
            onTouchTap={() => this.cancelSafeManagement()} />
        </PageBottomWithButtons>
      </Grid>
    );
  }
}

function mapStatetoProps(state) {
  return {
    safeManagementModel: selectSafeManagementModel(state, compName),
    saveSuccess: state.form[compName + "SaveSuccess"],
    saveError: state.form[compName + "SaveError"]
  };
}

function mapDispatchToProps(dispatch) {
  return {
    saveSafeManagement: (model) => dispatch(saveSafeManagement({ model, compName })),
    showSnackbar: (message) => dispatch(showSnackbar(message)),
    formError: (name, error) => dispatch({ type: 'FORM_ERROR', name, error }),
    clearFormInput: (name) => dispatch(clearFormInput(name))
  };
}

export default connect(mapStatetoProps, mapDispatchToProps)(SafeManagementSave);

